import {
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate } from "react-router-dom";
import SelectInputField from "../forms/formElements/SelectInputField";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import BasicAutoComplete from "../ui/BasicAutoComplete";
import { useAppSelector } from "../../redux/hooks";
import {
  filterConstants,
  mobileConstraints,
} from "../../constants/AppConstants";
import { useLocation } from 'react-router-dom';

export function AddUserAccess() {
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const location = useLocation();

  const {
    first_name = '', 
    last_name = '',
    email = '',
    mobileNumber = '',
    role = '',
    status = '',
    editMode = false
  } = location.state || {};


  const { merchantName: merchant, external_id } = selectedMerchatDetails;
  const [merchantData, setMerchantData] = useState<any[]>([]);
  const [statusState, setStatusState] = useState({ status: "" });
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [merchantLoading, setMerchantLoading] = useState(false);
  const [successMessageShowing, setSuccessMessageShowing] = useState("");
  const [errorMessageShowing, setErrorMessageShowing] = useState("");

  const [validationState, setValidationState] = useState({
    email: "",
  });
  const [merchantRoles, setMerchantRoles] = useState<string[]>([]);
  const buttonStyles = useButtonStyles();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    email: "",
    first_name: "",
    last_name: "",
    mobile: "",
    role: "",
  });
  useEffect(() => {
    if (first_name && last_name && email && mobileNumber && role) {
      setFormState({
        email,
        first_name,
        last_name,
        mobile: mobileNumber,
        role,
      });
    }
    
  }, [first_name, last_name, email, mobileNumber, role]);
  const [visited, setVisited] = useState({
    email: false,
    first_name: false,
    last_name: false,
    mobile: false,
    merchant: false,
    status: false,
  });

  const addShopUser = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL +
          APIConstants.addShopUser,
          {
            ...formState,
            merchant,
            ...statusState,
            external_id,
            module: "user_access",
            feature: "user_access",
          }
      );
      setSuccessMessageShowing(response.data);
      setApiSuccess(true);
      setOpenModal(true);
    } catch (error: any) {
      console.error(error);
      setApiSuccess(false);
      if (error?.response?.data?.message) {
        setErrorMessageShowing(error?.response?.data?.message);
      }
      setOpenModal(true);
    } finally {
      setLoading(false);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  };

  const EditShopUser = async () => {
    try {
     const response = await axios.put(
      process.env.REACT_APP_API_URL +
        APIConstants.addShopUser,
        {
          ...formState,
          merchant,
          mobile: formState?.mobile === "-" ? "" : formState?.mobile,
          ...statusState,
          external_id,
          module: "user_access",
          feature: "user_access",
        }
    );
    setSuccessMessageShowing(response?.data?.data || "Updated Successfully");
    setApiSuccess(true);
    setOpenModal(true);
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
      setTimeout(() => {
        navigate(-1);
      }, 2000);
    }
  };

  const formValidate = () => {
    if (formState.first_name === "") return false;
    if (formState.last_name === "") return false;
    // if (formState.mobile === "") return false;
    if (formState.email === "" || validationState.email !== "") return false;
    if (
      statusState.status === "" ||
      statusState.status === filterConstants.Select
    )
      return false;

    return true;
  };
  //
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;
        const roles = data.map((item: any) => {
          return item.name;
        });
        setMerchantRoles(roles);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchRoleList();
  }, []);

  return (
    <>
      <Grid
        container
        sx={{
          backgroundColor: theme?.color?.background,
          borderRadius: "16px",
        }}
        width={"100%"}
        alignSelf={"center"}
      >
        <Grid
          item
          display={"flex"}
          alignItems={"center"}
          px={6}
          gap={2}
          height={"6.25rem"}
          borderBottom={theme.border?.newGreyBorder}
          width={"100%"}
        >
          <Link to="/userAccess">
            <ArrowBackIosIcon sx={{ color: "black" }} />
          </Link>{" "}
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: "600",
              fontSize: theme.font?.fontSize.large,
            }}
          >
            {editMode ?  "Edit User" : "Add User"}
          </Typography>
        </Grid>
        <Grid item container p={4}>
          <Grid item container display={"flex"} justifyContent={"space-evenly"}>
            <Grid item md={3.5} lg={3.5} mx={1}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                First Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                value={formState.first_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    first_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    first_name: e.target.value,
                  }))
                }
                error={visited.first_name && formState.first_name === ""}
                helperText={
                  visited.first_name && formState.first_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item md={3.5} lg={3.5} mx={1}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Last Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                value={formState.last_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    last_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    last_name: e.target.value,
                  }))
                }
                error={visited.last_name && formState.last_name === ""}
                helperText={
                  visited.last_name && formState.last_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item md={3.5} lg={3.5} mx={1}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Mobile Number
              </Typography>
              <TextField
                type="number"
                fullWidth
                size="small"
                value={formState.mobile}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    mobile: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({ ...prev, mobile: e.target.value }))
                }
                error={
                  visited.mobile &&
                  (formState.mobile === "" ||
                    formState.mobile.length < mobileConstraints.mobileMin ||
                    formState.mobile.length > mobileConstraints.mobileMax)
                }
                helperText={
                  visited.mobile &&
                  (formState.mobile.length < mobileConstraints.mobileMin ||
                    formState.mobile.length > mobileConstraints.mobileMax)
                    ? "Invalid Number"
                    : ""
                }
              ></TextField>
            </Grid>
          </Grid>

          <Grid
            container
            item
            mt={2}
            display={"flex"}
            justifyContent={"space-evenly"}
          >
            <Grid item md={3.5} lg={3.5} mx={1}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Email *
              </Typography>
              <TextField
                fullWidth
                type="email"
                size="small"
                value={formState.email}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    email: true,
                  }))
                }
                onChange={(e) => {
                  const email = e.target.value;
                  setFormState((prev) => ({ ...prev, email }));
                  // Email validation using regex
                  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                  const isValidEmail = emailRegex.test(email);
                  setValidationState((prev) => ({
                    ...prev,
                    email: !isValidEmail ? "Invalid email address" : "",
                  }));
                }}
                error={
                  visited.email &&
                  (validationState.email !== "" || formState.email === "")
                }
                helperText={
                  visited.email && validationState.email !== ""
                    ? "Invalid email address"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item md={3.5} lg={3.5} mx={1}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Status
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setStatusState}
                stateKey="status"
                defaultValue={status || filterConstants.Select}
                align="left"
                options={[
                  filterConstants.Select,
                  filterConstants.Active,
                  filterConstants.Inactive,
                ]}
                error={
                  visited.status &&
                  (statusState?.status === "" ||
                    statusState?.status === filterConstants.Select)
                }
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    status: true,
                  }))
                }
              />
            </Grid>

            <Grid item md={3.5} lg={3.5} mx={1} >
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Role *
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setFormState}
                readOnly={editMode}
                stateKey="user_role"
                defaultValue={role || "Tenant Admin"}
                align="left"
                options={merchantRoles}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item width={"100%"}>
          <Grid
            container
            item
            justifyContent={"end"}
            padding={2}
            borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
            py={4}
            px={8}
          >
            <Button
              sx={{ ...buttonStyles.outlinedSecondary, width: "20%", mr: 4 }}
              variant="outlined"
              component={Link}
              to="/userAccess"
            >
              Cancel
            </Button>
            {editMode ?
              <Button
                type="submit"
                sx={{ ...buttonStyles.containedSecondary, width: "20%" }}
                variant="contained"
                onClick={EditShopUser}
                disabled={!formValidate()}
              >
                Update
              </Button>
              :
              <Button
                type="submit"
                sx={{ ...buttonStyles.containedSecondary, width: "20%" }}
                variant="contained"
                onClick={addShopUser}
                disabled={!formValidate()}
              >
                Save
              </Button>
            }
          </Grid>
        </Grid>
        {openModal && (
          <BasicModal
            title={apiSuccess ? successMessageShowing : errorMessageShowing}
            setState={setOpenModal}
            success={apiSuccess}
          />
        )}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </>
  );
}
